import { observer } from "mobx-react-lite";
import React from "react";
import { withFormWrapper } from "../withFormWrapper";
import { RadioButtons } from "../RadioButtons";
let warned = false;
const RawButtonRadio = observer(({ name, onChange, options }) => {
    if (!warned) {
        warned = true;
        console.warn("[piston-ux] ButtonRadio has been deprecated. Use <RadioButtons />.");
    }
    return React.createElement(RadioButtons, { name: name, onChange: onChange, options: options });
});
export const ButtonRadio = withFormWrapper({
    WrappedComponent: RawButtonRadio,
});
